


















import { formatFAIcon } from '../../../utils/formatter'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class BaseModal extends Vue {
  @Prop({ type: String, default: '' }) readonly header!: string
  @Prop({ type: String, default: '' }) readonly icon!: string
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean
  @Prop({ type: String, default: '' }) readonly iconColor!: string
  @Prop({ type: Boolean, default: false }) readonly disableClose?: boolean
  @Prop({ type: Boolean, default: false }) readonly center?: boolean


  get faIcon(): string {
    return formatFAIcon(this.icon)
  }
}
